module.exports = __webpack_public_path__ + "assets/img/scenic_11.9ad1d949.svg";